module.exports = __webpack_public_path__ + "img/usp.79513317.png";